import store from "@/store";
import Vue from "vue";
import VueRouter, { isNavigationFailure } from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "chunk-one" */ "../views/LoginPage.vue"),
    children: [
      {
        path: "/login",
        name: "PasswordLogin",
        component: () =>
          import(/* webpackChunkName: "chunk-one" */ "@/components/pages/Login/passwordLogin.vue"),
        meta: { public: true, title: "Functionize Agentic Automation Platform" },
      },
      {
        path: "sso",
        name: "SsoLogin",
        component: () =>
          import(/* webpackChunkName: "chunk-one" */ "@/components/pages/Login/ssoLogin.vue"),
        meta: { public: true, title: "Functionize Agentic Automation Platform" },
      },
      {
        path: "otp",
        name: "OtpLogin",
        component: () =>
          import(/* webpackChunkName: "chunk-one" */ "@/components/pages/Login/OtpConfirm.vue"),
        meta: { public: true, title: "Functionize Agentic Automation Platform" },
      },
      {
        path: "/account/forgot",
        name: "ForgotPassword",
        component: () => import(/* webpackChunkName: "chunk-one" */ "../views/ForgotPassword.vue"),
        meta: { public: true, title: "Forgot Password" },
      },
      {
        path: "/account/reset/:resetPassToken",
        name: "ResetPassword",
        component: () => import(/* webpackChunkName: "chunk-one" */ "../views/ResetPassword.vue"),
        meta: { public: true, title: "Reset Password" },
      },
      {
        path: "/account/signup/user/:inviteToken",
        name: "InviteSignup",
        component: () => import(/* webpackChunkName: "chunk-one" */ "../views/InviteSignup.vue"),
        meta: { public: true, title: "Signup Invitation" },
      },
      {
        path: "/account/signup/team/:signupToken",
        name: "TokenSignup",
        component: () => import(/* webpackChunkName: "chunk-one" */ "../views/TokenSignup.vue"),
        meta: { public: true, title: "Team Invitation Signup" },
      },
    ],
  },

  {
    path: "/product-listing-generator",
    name: "ProductListingGenerator",
    component: () =>
      import(/* webpackChunkName: "chunk-two" */ "../views/ProductListingGenerator.vue"),
    meta: { title: "Product Listing Generator" },
  },
  {
    path: "/url-hit",
    name: "UrlHit",
    component: () => import(/* webpackChunkName: "chunk-two" */ "../views/UrlHit.vue"),
    meta: { title: "Url Hit Generator" },
  },
  {
    path: "/system-admin",
    name: "SystemAdmin",
    component: () => import(/* webpackChunkName: "chunk-two" */ "../views/SystemAdmin.vue"),
    meta: { title: "System Admin" },
  },
  {
    path: "/internal-tools",
    name: "InternalTools",
    component: () => import(/* webpackChunkName: "chunk-two" */ "../views/InternalTools.vue"),
    meta: { title: "Internal Tools", internal: true },
  },
  {
    path: "/tdm",
    name: "TDM",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/TDM.vue"),
    meta: { title: "TDM", package: "TDM", rbac: "viewtdm", disableFlag: "hideTDM" },
  },
  {
    path: "/record",
    name: "Record",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/Record.vue"),
    meta: { title: "Record" },
  },
  {
    path: "/team",
    name: "Team",
    component: () => import(/* webpackChunkName: "chunk-team" */ "../views/Team.vue"),
    meta: { title: "Team", rbac: "manageteam" },
    children: [
      {
        path: "/",
        name: "TeamList",
        component: () =>
          import(/* webpackChunkName: "chunk-team" */ "../components/pages/Team/TeamList.vue"),
        meta: { title: "Team", rbac: "manageteam" },
      },
      {
        path: "alerts",
        name: "Alerts",
        component: () =>
          import(/* webpackChunkName: "chunk-team" */ "../components/pages/Team/Alerts.vue"),
        meta: { title: "Team : Alerts", rbac: "manageteam" },
      },
      {
        path: "settings",
        name: "Settings",
        component: () =>
          import(/* webpackChunkName: "chunk-team" */ "../components/pages/Team/Settings.vue"),
        meta: { title: "Team : Settings", rbac: "manageteam" },
      },
      {
        path: "browsers",
        name: "Browsers",
        component: () =>
          import(/* webpackChunkName: "chunk-team" */ "../components/pages/Team/Browsers.vue"),
        meta: { title: "Team : Browsers", rbac: "manageteam" },
      },
      {
        path: "resource-tracker",
        name: "ResourceTracker",
        component: () =>
          import(
            /* webpackChunkName: "chunk-team" */ "../components/pages/Team/ResourceTracker.vue"
          ),
        meta: { title: "Team : Resource Tracker", rbac: "manageteam" },
      },
      {
        path: "sso",
        name: "SSO",
        component: () =>
          import(/* webpackChunkName: "chunk-team" */ "../components/pages/Team/SSO.vue"),
        meta: { title: "Team : SSO", package: "SSO", rbac: "manageteam" },
      },
      {
        path: "phone-numbers",
        name: "PhoneNumbers",
        component: () =>
          import(/* webpackChunkName: "chunk-team" */ "../components/pages/Team/PhoneNumbers.vue"),
        meta: { title: "Team : Phone Numbers", rbac: "manageteam" },
      },
      {
        path: "import-project",
        name: "ImportProject",
        component: () =>
          import(/* webpackChunkName: "chunk-team" */ "../components/pages/Team/ImportProject.vue"),
        meta: {
          title: "Team : Import Project",
          rbac: "manageteam",
          admin: true,
          flag: "enableExportImportProject",
        },
      },
      //Add New view here before InvalidRoute and CatchAllRoute
      {
        path: "integration",
        component: () =>
          import(
            /* webpackChunkName: "chunk-integration" */ "../components/pages/Team/Integration.vue"
          ),
        meta: { title: "Integration", rbac: "manageteam" },
        children: [
          {
            path: "/",
            name: "Integration",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/DefaultIntegration.vue"
              ),
            meta: { title: "Integration " },
          },
          // {
          //   path: "Testrail",
          //   name: "TestRail",
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Testrail.vue"
          //       ),
          //   meta: { title: "Integration :: Test Rail" }
          // },
          {
            path: "Jenkins",
            name: "Jenkins",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Jenkins.vue"
              ),
            meta: { title: "Integration :: Jenkins" },
          },
          {
            path: "CircleCI",
            name: "CircleCI",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/CircleCI.vue"
              ),
            meta: { title: "Integration :: Circle CI" },
          },
          {
            path: "AWSCodePipeline",
            name: "AWSCodePipeline",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/AWSCodePipeline.vue"
              ),
            meta: { title: "Integration :: AWS CodePipeline" },
          },
          {
            path: "ADO",
            name: "ADO",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/ADO.vue"
              ),
            meta: { title: "Integration :: ADO" },
          },
          {
            path: "Pagerduty",
            name: "Pagerduty",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Pagerduty.vue"
              ),
            meta: { title: "Integration :: PagerDuty" },
          },
          {
            path: "Github",
            name: "Github",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Github.vue"
              ),
            meta: { title: "Integration :: Github" },
          },
          {
            path: "Heroku",
            name: "Heroku",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Heroku.vue"
              ),
            meta: { title: "Integration :: Heroku" },
          },
          {
            path: "Jira",
            name: "Jira",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Jira.vue"
              ),
            meta: { title: "Integration :: Jira" },
          },
          {
            path: "Spinnakerio",
            name: "Spinnakerio",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Spinnakerio.vue"
              ),
            meta: { title: "Integration :: Spinnaker.io" },
          },
          {
            path: "TravisCI",
            name: "TravisCI",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/TravisCI.vue"
              ),
            meta: { title: "Integration :: Travis CI" },
          },
          {
            path: "Xray",
            name: "Xray",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Xray/XrayView.vue"
              ),
            meta: { title: "Integration :: Xray" },
            children: [
              {
                path: ":id(\\d+)",
                name: "Xray-Child",
                component: () =>
                  import(
                    /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Xray/XrayMapping.vue"
                  ),
                meta: { title: "XrayMapping " },
              },
            ],
          },
          {
            path: "JiraDefect",
            name: "JiraDefect",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/JiraDefect/JiraView.vue"
              ),
            meta: { title: "Integration :: JiraDefect" },
            children: [
              {
                path: ":id(\\d+)",
                name: "Jira-Child",
                component: () =>
                  import(
                    /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/JiraDefect/JiraMapping.vue"
                  ),
                meta: { title: "JiraMapping " },
              },
            ],
          },
          {
            path: "Sealights",
            name: "Sealights",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Sealights.vue"
              ),
            meta: { title: "Integration :: Sealights" },
          },
          {
            path: "Slack",
            name: "Slack",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Slack.vue"
              ),
            meta: { title: "Integration :: Slack" },
          },
          {
            path: "PagerDutyOut",
            name: "PagerDutyOut",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/PagerDutyOut.vue"
              ),
            meta: { title: "Integration :: PagerDuty" },
          },
          {
            path: "ZephyrSquad",
            name: "ZephyrSquad",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/ZephyrSquad/ZephyrView.vue"
              ),
            meta: { title: "Integration :: ZephyrSquad" },
            children: [
              {
                path: ":id(\\d+)",
                name: "Zephyr-Child",
                component: () =>
                  import(
                    /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/ZephyrSquad/ZephyrMapping.vue"
                  ),
                meta: { title: "ZephyrMapping " },
              },
            ],
          },
          {
            path: "TestRail",
            name: "TestRail",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/TestRail/TestRailView.vue"
              ),
            meta: { title: "Integration :: TestRail" },
            children: [
              {
                path: ":id(\\d+)",
                name: "TestRail-Child",
                component: () =>
                  import(
                    /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/TestRail/TestRailMapping.vue"
                  ),
                meta: { title: "TestRail " },
              },
            ],
          },
          {
            path: "Rally",
            name: "Rally",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Rally/RallyView.vue"
              ),
            meta: { title: "Integration :: Rally" },
            children: [
              {
                path: ":id(\\d+)",
                name: "Rally-Child",
                component: () =>
                  import(
                    /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/Rally/RallyMapping.vue"
                  ),
                meta: { title: "Rally " },
              },
            ],
          },
          {
            path: "AzureDevOps",
            name: "AzureDevOps",
            component: () =>
              import(
                /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/AzureDevOps/AzureDevView.vue"
              ),
            meta: { title: "Integration :: AzureDevOps", flag: "enable_ado" },
            children: [
              {
                path: ":id(\\d+)",
                name: "AzureDevOps-Child",
                component: () =>
                  import(
                    /* webpackChunkName: "chunk-integration" */ "@/components/pages/Integration/AzureDevOps/AzureDevMapping.vue"
                  ),
                meta: { title: "AzureDevOps ", flag: "enable_ado" },
              },
            ],
          },
          // {
          //   path: "Rally",
          //   name: "Rally",
          //   component: () =>
          //     import(
          //       /* webpackChunkName: "chunk-two" */ "@/components/pages/Integration/Rally.vue"
          //       ),
          //   meta: { title: "Integration :: Rally" }
          // }
        ],
      },
    ],
  },
  {
    path: "/orchestrations",
    name: "Orchestrations",
    component: () =>
      import(/* webpackChunkName: "chunk-orchestration" */ "../views/Orchestrations.vue"),
    meta: { title: "Orchestrations", flag: "orchestration_access" },
  },
  {
    path: "/orchestrations-report/:id(\\d+)/:runId(\\w*)?",
    name: "OrchestrationsReport",
    component: () =>
      import(/* webpackChunkName: "chunk-orchestration" */ "../views/OrchestrationReport.vue"),
    meta: {
      title: "Orchestration Report",
      package: "BASICREPORTING",
      flag: "orchestration_access",
    },
  },
  {
    path: "/orchestrations-audit-log/:id(\\d+)",
    name: "OrchestrationAuditLog",
    component: () =>
      import(/* webpackChunkName: "chunk-orchestration" */ "../views/OrchestrationAuditLog.vue"),
    meta: {
      title: "Orchestration Audit Log",
      flag: "orchestration_access",
      package: "ADVANCEDAUDITINGLOGGING",
    },
  },
  {
    path: "/extensions",
    name: "Extensions",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/Extensions.vue"),
    meta: { title: "Extensions", rbac: "extensions", disableFlag: "hideExtensions" },
  },
  {
    path: "/load-tests",
    name: "LoadTest",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/LoadTest.vue"),
    meta: { title: "Load Test", internal: true, flag: "enable_load_test" },
  },
  {
    path: "/load-tests-report/:id(\\d+)/:runId([\\w-]*)?",
    name: "LoadTestReport",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/LoadTestReport.vue"),
    meta: { title: "Load Test- Report", internal: true, flag: "enable_load_test" },
  },
  {
    path: "/manage-user",
    name: "ManageUser",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/ManageUser.vue"),
    meta: { title: "Manage User", internal: true, admin: true },
  },
  {
    path: "/manage-team",
    name: "ManageTeam",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/ManageTeam.vue"),
    meta: { title: "Manage Team", internal: true, admin: true },
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/Signup.vue"),
    meta: { title: "Signup", internal: true, admin: true, flag: "isSignupAccess" },
  },
  {
    path: "/runtime-issue",
    name: "RuntimeIssue",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/RuntimeIssue.vue"),
    meta: { title: "Runtime Issue", internal: true, admin: true },
  },
  {
    path: "/runtime-version",
    name: "RuntimeVersion",
    component: () => import(/* webpackChunkName: "chunk-three" */ "../views/RuntimeVersion.vue"),
    meta: { title: "Runtime Version", internal: true, admin: true },
  },
  {
    path: "/modeling-failed-comments",
    name: "ModelingFailedComments",
    component: () =>
      import(/* webpackChunkName: "chunk-four" */ "../views/ModelingFailedComments.vue"),
    meta: { title: "Modeling Failed Comments", internal: true, admin: true },
  },
  {
    path: "/fix-test-request",
    name: "FixTestRequest",
    component: () => import(/* webpackChunkName: "chunk-four" */ "../views/FixTestRequest.vue"),
    meta: { title: "Fix Test Request", internal: true, admin: true },
  },
  {
    path: "/compare-result/:id",
    name: "CompareResult",
    component: () =>
      import(
        /* webpackChunkName: "chunk-four" */ "@/components/pages/Orchestrations/CompareResult.vue"
      ),
    meta: { title: "CompareResult", internal: true, admin: true },
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import(/* webpackChunkName: "chunk-project" */ "../views/Projects.vue"),
    meta: { title: "Projects" },
  },
  {
    path: "/project-v1/:id(\\d+)",
    name: "TestCaseListing",
    component: () =>
      import(/* webpackChunkName: "chunk-project" */ "../views/TestCaseListingPage.vue"),
    meta: { title: "TestCaseListing" },
  },
  {
    path: "/project/:id(\\d+)",
    name: "Project",
    component: () => import(/* webpackChunkName: "chunk-project" */ "../views/Project.vue"),
    meta: { title: "Project" },
  },
  {
    path: "/project/:id(\\d+)/init/:init(\\d+)/test/:test(\\d+)",
    name: "Project Init Test",
    component: () => import(/* webpackChunkName: "chunk-project" */ "../views/Project.vue"),
    meta: { title: "Project" },
  },
  {
    path: "/customer-dashboard",
    name: "CustomerDashboard",
    component: () => import(/* webpackChunkName: "chunk-four" */ "../views/CustomerDashboard.vue"),
    meta: { title: "Dashboard- Functionize", internal: true },
  },
  {
    path: "/page-objects-group",
    name: "PageObjectsGroup",
    component: () =>
      import(/* webpackChunkName: "chunk-four" */ "../views/PageObjectGroupList.vue"),
    meta: { title: "Page Objects Group", flag: "enableSyncPageObjects" , rbac: "managegrouppageobject" },
  },
  {
    path: "/live-debug-logs/:id(\\d+)",
    name: "LiveDebugLogs",
    component: () => import(/* webpackChunkName: "chunk-four" */ "../views/LiveDebugLogs.vue"),
    meta: { title: "Live Debug Logs- Functionize", internal: true },
  },
  {
    path: "/customer-report",
    name: "CustomerReport",
    component: () => import(/* webpackChunkName: "chunk-four" */ "../views/CustomerReport.vue"),
    meta: { title: "Customer- Report", package: "BASICREPORTING", internal: true },
  },
  {
    path: "/json-viewer",
    name: "JsonViewer",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/JsonViewer.vue"),
    meta: { title: "Json Viewer", internal: true },
  },
  {
    path: "/encoder",
    name: "Encoder",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/Encoder.vue"),
    meta: { title: "Encoder", internal: true },
  },
  {
    path: "/reports",
    name: "Report",
    component: () => import(/* webpackChunkName: "chunk-report" */ "../views/Reports.vue"),
    children: [
      {
        path: "/",
        name: "TestHealth",
        component: () =>
          import(
            /* webpackChunkName: "chunk-report" */ "../components/pages/Reports/TestHealth.vue"
          ),
        meta: { title: "Test Health", package: "BASICREPORTING", rbac: "generalreport" },
      },
      {
        path: "browser-health",
        name: "BrowserHealth",
        component: () =>
          import(
            /* webpackChunkName: "chunk-report" */ "../components/pages/Reports/BrowserHealth.vue"
          ),
        meta: { title: "Browser Health", package: "BASICREPORTING", rbac: "generalreport" },
      },
      {
        path: "teams",
        name: "Teams",
        component: () =>
          import(/* webpackChunkName: "chunk-report" */ "../components/pages/Reports/Teams.vue"),
        meta: { title: "Teams", package: "BASICREPORTING", rbac: ["generalreport", "teamreport"] },
      },
      {
        path: "usage-quota",
        name: "UsageQuota",
        component: () =>
          import(
            /* webpackChunkName: "chunk-report" */ "../components/pages/Reports/UsageQuota.vue"
          ),
        meta: {
          title: "Usage Quota",
          package: "BASICREPORTING",
          rbac: ["generalreport", "quotareport"],
        },
      },
    ],
  },
  {
    path: "/:type(test|po)/:id(\\d+)/audit-log",
    name: "AuditLog",
    component: () => import(/* webpackChunkName: "chunk-four" */ "../views/AuditLog.vue"),
    meta: { title: "Audit Log", package: "ADVANCEDAUDITINGLOGGING" },
  },
  {
    path: "/profile",
    component: () => import(/* webpackChunkName: "chunk-profile" */ "../views/Profile.vue"),
    children: [
      {
        path: "/",
        name: "MyProfileTab",
        component: () =>
          import(
            /* webpackChunkName: "chunk-profile" */ "../components/pages/Profile/MyProfileTab.vue"
          ),
        meta: { title: "Profile" },
      },
      {
        path: "alert",
        name: "AlertTab",
        component: () =>
          import(
            /* webpackChunkName: "chunk-profile" */ "../components/pages/Profile/AlertTab.vue"
          ),
        meta: { title: "Profile: Alert" },
      },
      {
        path: "api-keys",
        name: "ApiKeys",
        component: () =>
          import(/* webpackChunkName: "chunk-profile" */ "../components/pages/Profile/ApiKeys.vue"),
        meta: { title: "Profile: API Keys", rbac: "apikeys" },
      },
      {
        path: "proxy",
        name: "ProxySettingsTab",
        component: () =>
          import(
            /* webpackChunkName: "chunk-profile" */ "../components/pages/Profile/ProxySettingsTab.vue"
          ),
        meta: { title: "Profile: Proxy Settings" },
      },
    ],
  },
  {
    path: "/internal-report",
    name: "InternalReport",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/InternalReport.vue"),
    meta: { internal: true, title: "Internal Report" },
  },
  {
    path: "/review-tests",
    name: "ReviewTests",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/ReviewTests.vue"),
    meta: { internal: true, title: "Review Tests" },
  },
  {
    path: "/api-documentation",
    name: "ApiDocumentation",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/ApiDocumentation.vue"),
    meta: { title: "API Documentation", rbac: "swagger" },
  },
  {
    path: "/test/:id(\\d+)/",
    component: () => import(/* webpackChunkName: "detail-page" */ "../views/TestDetail.vue"),
    meta: { title: "Test Detail", internal: true },
    children: [
      {
        path: "",
        name: "DetailPage",
        component: () =>
          import(
            /* webpackChunkName: "detail-page" */ "../components/pages/TestDetail/Browser.vue"
          ),
      },
      {
        path: "browser/:browserId(\\d+)",
        name: "DetailPageBrowser",
        component: () =>
          import(
            /* webpackChunkName: "detail-page" */ "../components/pages/TestDetail/Browser.vue"
          ),
      },
      {
        path: "history",
        name: "TestHistory",
        component: () =>
          import(
            /* webpackChunkName: "detail-page" */ "../components/pages/TestDetail/Components/HistoryTab.vue"
          ),
      },
    ],
  },
  {
    path: "/test/:id(\\d+)/slider/:actionId",
    name: "SliderViewScreenshot",
    component: () =>
      import(/* webpackChunkName: "chunk-six" */ "../views/SliderView/SliderView.vue"),
    meta: { title: "Slider Action Detail", internal: true },
  },
  {
    path: "/test/:id(\\d+)/browser/:browserId/slider/:actionId",
    name: "SliderView",
    component: () =>
      import(/* webpackChunkName: "chunk-six" */ "../views/SliderView/SliderView.vue"),
    meta: { title: "Slider Action Detail", internal: true },
  },
  {
    path: "/rbac/site-admin",
    name: "SiteAdmin",
    component: () =>
      import(/* webpackChunkName: "rbac-page" */ "../components/pages/Rbac/SiteAdmin.vue"),
    meta: { title: "Site Admin", flag: "role_level", value: "1" },
  },
  {
    path: "/rbac/project-admin/:id?",
    name: "ProjectAdmin",
    component: () =>
      import(/* webpackChunkName: "rbac-page" */ "../components/pages/Rbac/ProjectAdmin.vue"),
    meta: {
      title: "Project Admin",
      flag: "role_level",
      value: ["1", "2", "6"],
      rbac: "manageprojects",
    },
  },
  {
    path: "/rbac/roles",
    name: "Roles",
    component: () =>
      import(/* webpackChunkName: "rbac-page" */ "../components/pages/Rbac/Roles.vue"),
    meta: {
      title: "Roles",
      flag: "role_level",
      value: "1",
      orFlag: "isRBACManageAccess",
    },
  },
  {
    path: "/rbac/site-users",
    name: "SiteUsers",
    component: () =>
      import(/* webpackChunkName: "rbac-page" */ "../components/pages/Rbac/SiteUsers.vue"),
    meta: { title: "Site-Users", flag: "role_level", value: "1" },
  },
  {
    path: "/rbac/team-admin",
    name: "TeamAdmin",
    component: () =>
      import(/* webpackChunkName: "rbac-page" */ "../components/pages/Rbac/TeamAdmin.vue"),
    meta: { title: "Team-Admin", flag: "role_level", value: ["1", "2"] },
  },
  // {
  //   path: "/request-demo",
  //   name: "RequestDemo",
  //   component: () => import(/* webpackChunkName: "chunk-four" */ "../views/RequestDemo.vue"),
  //   meta: { title: "Request-Demo", internal: true },
  // },
  {
    path: "/resource",
    name: "Resource",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/Resource.vue"),
    meta: { title: "Resource", internal: true, flag: "is_resources_access" },
  },
  {
    path: "/email-tracker",
    name: "EmailTracker",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/EmailTracker.vue"),
    meta: { title: "Email-Tracker", internal: true, flag: "emailtrackeraccessemailsFlag" },
  },
  {
    path: "/runtime-stream",
    name: "RuntimeStream",
    component: () => import(/* webpackChunkName: "chunk-five" */ "../views/RuntimeStream.vue"),
    meta: { title: "Runtime-Stream", internal: true, flag: "allowstreammanagement" },
  },
  {
    path: "/share/orchestrations-report/:token",
    name: "ShareOrchestrationsReport",
    component: () => import(/* webpackChunkName: "chunk-six" */ "../views/OrchestrationReport.vue"),
    meta: { title: "Orchestration Report", public: true },
  },
  //Add New view here before InvalidRoute and CatchAllRoute
  {
    path: "/invalid-access",
    name: "InvalidRoute",
    component: () => import(/* webpackChunkName: "chunk-six" */ "../views/InvalidRoute.vue"),
    meta: { public: true, title: "Resource Not Found" },
  },
  {
    path: "/invalid-permission",
    name: "InvalidPermission",
    component: () => import(/* webpackChunkName: "chunk-six" */ "../views/InvalidPermission.vue"),
    meta: { public: true, title: "Invalid Permission" },
  },
  {
    path: "/audit-logs/:type/:id(\\d+)",
    name: "AuditLogs",
    component: () => import(/* webpackChunkName: "chunk-six" */ "../views/AuditLogs.vue"),
    meta: { title: "Audit Logs", internal: true },
  },
  {
    path: "/diagnostic-error-report",
    name: "DiagnosticErrorReport",
    component: () =>
      import(/* webpackChunkName: "chunk-six" */ "../views/DiagnosticErrorReport.vue"),
    meta: { title: "Diagnostic Error Report", internal: true },
  },
  {
    path: "*",
    name: "CatchAllRoute",
    component: () => import(/* webpackChunkName: "chunk-six" */ "../views/CatchAllRoute.vue"),
    meta: { public: true },
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    console.log({ err });
  });
};

const originalReplace = VueRouter.prototype.push;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    console.log({ err });
  });
};

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
});

const boolean = (value) => ["1", 1, true, "true"].includes(value);

router.beforeEach((to, from, next) => {
  store.commit("setInvalidRoute", false);
  if (to.meta?.public) {
    next();
  } else {
    if (store.state.window.is_login) {
      let invalid = false;
      if (to.meta?.internal) {
        if (store.state.window.is_user_tester) {
        } else {
          invalid = true;
          store.commit("setInvalidRoute", true);
        }
      }
      if (to.meta?.admin) {
        if ([1, "1"].includes(store.state.window.adminrole)) {
        } else {
          invalid = true;
          store.commit("setInvalidRoute", true);
        }
      }
      if (to.meta?.flag) {
        let value = to.meta?.value;
        if (value) {
          if (!Array.isArray(value)) {
            value = [value];
          }
          if (
            value.includes(String(store.state.window?.[to.meta.flag])) ||
            boolean(store.state.window?.[to.meta?.orFlag])
          ) {
          } else {
            invalid = true;
            store.commit("setInvalidRoute", true);
          }
        } else {
          if (
            boolean(store.state.window?.[to.meta.flag]) ||
            boolean(store.state.window?.[to.meta?.orFlag])
          ) {
          } else {
            invalid = true;
            store.commit("setInvalidRoute", true);
          }
        }
      }
      if (to.meta?.disableFlag) {
        if (["1", "true"].includes(String(store.state.window?.[to.meta.disableFlag]))) {
          invalid = true;
          store.commit("setInvalidRoute", true);
        }
      }

      if (store.state.window?.checkAccessInfo?.invalid_access) {
        if (store.state.window.is_user_tester && false) {
        } else {
          invalid = true;
          store.commit("setInvalidRoute", true);
        }
      }
      if (
        ["1", 1, true, "true"].includes(store.state.window.is_turk_test) &&
        ["Projects", "Report", "Orchestrations", "TDM"].includes(to.name)
      ) {
        window.location.href = "/turkjobs";
      }
      const access = store.state.window?.packagemoduleaccess ?? {};
      const accessPackage = to.meta?.package ?? "";
      if (accessPackage) {
        if (String(access?.[accessPackage]?.access) === "1" && !invalid) {
          next();
        } else {
          if (access?.[accessPackage]) {
            invalid = true;
            store.commit("setInvalidRoute", true);
          } else {
            next();
          }
        }
      } else {
        if (!invalid) next();
      }

      const moduleAccess = store.state.window?.moduleaccess ?? {};

      let rbac = to.meta?.rbac ?? "";
      if (rbac && !Array.isArray(rbac)) {
        rbac = [rbac];
      }
      if (rbac) {
        rbac.find((x) => {
          if (x) {
            if (String(moduleAccess?.[x]?.access) === "1" && !invalid) {
              next();
            } else {
              if (store.state.window?.current_site_id) {
                invalid = true;
                store.commit("setInvalidRoute", true);
                return false;
              } else {
                if (x === "manageteam") {
                  if (store.state.window.teamowner) {
                    next();
                  } else {
                    invalid = true;
                    store.commit("setInvalidRoute", true);
                    return false;
                  }
                } else {
                  next();
                }
              }
            }
          } else {
            if (!invalid) next();
          }
          return true;
        });
      }
    } else {
      next({
        name: "PasswordLogin",
        query: { url: "v1" + to.fullPath },
      });
    }
  }
  if (store.state.window?.checkAccessInfo?.invalid_access) {
    store.commit("setInvalidRoute", true);
  }
});

const DEFAULT_TITLE = "Functionize";
router.afterEach((to, from, failure) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
  if (isNavigationFailure(failure)) {
    console.log("failed navigation", failure);
  }
});

export default router;
